import fly from './fly'
import flyFormData from './fly-form-data'
import { getAuth } from '@/util/storage'
const auth = getAuth()

//获取用户基本信息
export const getUserInfoApi = () => fly.get(`/mall/user/info.json`, { auth })
//上传图片
export const uploadPictureApi = (params: object) => flyFormData.post(`/newmall-image/common/uploadImg.json`, params)
//更新用户基本信息
export const updateUserInfoApi = (params: object) => flyFormData.post(`/base/user/edit.json`,params)
//通知中心消息
export const getNotificationApi = (params:object) => fly.get(`/mall/notice/lists.json`, { auth,...params })

//设置消息已阅读
export const setreadNoticeApi = (params:object) => fly.get(`/mall/notice/setread.json`, { auth,...params })
//获取通知消息详情
export const noticedetailApi = (url:string,params:object) => fly.get(url, { auth,...params })
//获取合同明细
export const contractDetailApi = (params:object) => fly.get(`/mall/notice/contract/detail.json`, { auth,...params })
//消息审核通过
export const noticeChangeStatusApi= (params:object) => flyFormData.post(`/base/notice/changeStatusNew.json`, params)

//报修类型列表
export const fetchType = () => fly.get('/baseUseMallKey/repair-api/front/type', { auth })